import { IAttendeeOrganizationDTO } from '../../../../../../../../../../api/attendees.dao';
import { IAccountContactListItemDTO } from '../../../../../../../../../../api/account-contacts.dao';
import { ISpeakerReferenceDTO } from '../../../../../../../../../../api/event-hubs.dao';

const toOrganizationItems = (contacts: IAccountContactListItemDTO[]): IAttendeeOrganizationDTO[] => {
    const organizations = new Map<number, IAttendeeOrganizationDTO>();

    contacts.forEach(contact => {
        const attendee = {
            attendeeId: contact.accountContactId,
            firstName: contact.firstName,
            lastName: contact.lastName,
        };
        const organization = organizations.get(contact.accountOrganizationId);

        if (organization) {
            organization.attendees.push(attendee);
        } else {
            organizations.set(contact.accountOrganizationId, {
                organizationId: contact.accountOrganizationId,
                name: contact.organizationName,
                attendees: [attendee],
            });
        }
    });

    return [...organizations.values()];
};

const getAlreadyAddedItems = (
    contacts: IAccountContactListItemDTO[],
    speakers: ISpeakerReferenceDTO[],
): IAttendeeOrganizationDTO[] => {
    const addedContactIds = new Set(speakers.map(speaker => speaker.accountContactId));

    return toOrganizationItems(contacts.filter(contact => addedContactIds.has(contact.accountContactId)));
};

const getSelectedContacts = (
    selectedOrganizations: IAttendeeOrganizationDTO[],
    contacts: IAccountContactListItemDTO[],
): IAccountContactListItemDTO[] => {
    const selectedContactIds = new Set(
        (selectedOrganizations ?? []).flatMap(organization => (organization.attendees ?? []).map(attendee => attendee.attendeeId)),
    );

    return contacts.filter(contact => selectedContactIds.has(contact.accountContactId));
};

export { getAlreadyAddedItems, getSelectedContacts, toOrganizationItems };
